<template>
  <div>
    <div :class="['b-share hidden sm:hidden', size ? size : '']">
      <!-- ↓↓CRM独自対応(共有アイコン非表示化)start↓↓ -->
      <!-- <span class="lg:hidden">{{ label }}</span>
      <a
        class="b-share-item lg:hidden"
        target="_blank"
        :href="shareFacebook"
        v-if="facebook"
      >
        <i class="icon icon-bor-facebook" />
      </a>
      <a
        class="b-share-item lg:hidden"
        target="_blank"
        :href="shareTwitter"
        v-if="twitter"
      >
        <i class="icon icon-bor-twitter" />
      </a>
      <a class="b-share-item lg:hidden" target="_blank" :href="shareLine" v-if="line">
        <i class="icon icon-bor-line" />
      </a> -->
      <!-- <a class="b-share-item lg:hidden" target="_blank" :href="shareEmail" v-if="email">
        <i class="icon icon-bor-envelope" />
      </a> -->
      <!-- <a class="b-share-item lg:hidden" @click="handleMail()" v-if="email">
        <i class="icon icon-bor-envelope" />
      </a> -->
      <!-- TOP-MAIL -->
      <!-- <PopUpSendMail
        :visible="popupMail"
        @show="showPopup"
        @sendMail="sendMailToAddress"
        :errCode="errCode"
      />
      <div class="divider-v lg:hidden"></div>
      <div class="item-action lg:hidden" v-if="copy">
        <button class="c-btn btn-sm btn-white btn-copy" @click="doCopy">
          内容をコピー
        </button>
      </div> -->
      <!-- ↑↑CRM独自対応(共有アイコン非表示化)↑↑ -->
      <div class="item-action hidden lg:block" v-if="favorite">
        <a @click="handleFavorite">
          <!-- ライフエール独自対応 -->
          <i class="icon icon-bor-heart-solid" style="color: #da291c;" v-if="isFavorite" />
          <i class="icon icon-bor-heart-plus" style="color: #da291c;" v-else />
        </a>
      </div>
      <!-- CRM独自対応 -->
      <!-- <div class="item-action hidden lg:block sm:hidden">
        <a class="text-grey-600" href="#">
          <i class="icon icon-bor-circle-question" />
        </a>
      </div>
      <div class="item-action hidden lg:block">
        <a href="#" @click="showShare">
          <i class="icon icon-bor-upload share"></i>
        </a>
      </div> -->
    </div>
    <InstructionLogin1
      :visible="popupLogin"
      @ok="popupLogin = false"
      @cancel="popupLogin = false"
    />
    <!-- ↓↓CRM独自対応(共有アイコン非表示化)start↓↓※取込元の新BSのソース自体にコメントが存在するため、局所的にコメント化 -->
    <!-- <Modal title="共有" :visible="popupShare" @ok="popupShare = false" @cancel="popupShare = false">
      <div class="b-share_inner"> -->
        <!-- <a
          class="b-share-item lg:hidden"
          target="_blank"
          :href="shareFacebook"
          v-if="facebook"
        >
          <i class="icon icon-bor-facebook" />
        </a>
        <a
          class="b-share-item lg:hidden"
          target="_blank"
          :href="shareTwitter"
          v-if="twitter"
        >
          <i class="icon icon-bor-twitter" />
        </a> -->
        <!-- <a class="b-share-item lg:hidden" target="_blank" :href="shareLine" v-if="line">
          <i class="icon icon-bor-line" />
        </a>
        <a class="b-share-item b-share-item-sp lg:hidden" target="_blank" :href="shareEmail" v-if="email">
          <i class="icon icon-bor-envelope" />
        </a>
        <a class="b-share-item b-share-item-pc sm:hidden" @click="handleMail()" v-if="email">
        <i class="icon icon-bor-envelope" />
        </a> -->
        <!-- <a v-if="copy" class="b-share-item b-share-item-sp btn-copy" @click.stop="doCopy">
          <i class="icon icon-bor-copy" />
        </a> -->
        <!-- <div class="b-share-item lg:hidden" v-if="copy">
        <button class="c-btn btn-sm btn-white btn-copy" @click="doCopy">
          URLをコピー
        </button>
      </div>
      </div>
    </Modal> -->
    <!-- ↑↑CRM独自対応(共有アイコン非表示化)end↑↑ -->

    <!-- mobile share and favourite icon wrapper -->
    <div class="share-favourite flex justify-center items-center">
        <!-- ↓↓CRM独自対応(共有アイコン非表示化)start↓↓ -->
        <!-- <div @click="showShare" class="share-icon-wrapper border flex gap-1 justify-center items-center cursor-pointer">
            <span class="txt whitespace-pre">共有</span>
            <span class="icon"><i class="icon icon-bor-upload share"></i></span>
        </div> -->
        <!-- ↑↑CRM独自対応(共有アイコン非表示化)end↑↑ -->
        <div class="favourite-icon-wrapper" @click="handleFavorite">
            <i class="icon icon-bor-heart-solid" v-if="isFavorite" />
            <i class="icon icon-bor-heart" v-else />
        </div>
    </div>

  </div>
</template>

<script>
import get from 'lodash/get'
import menu_utils from '@/mixins/menu_utils'
import func_utils from '@/mixins/func_utils'
import _ from 'lodash'
// ライフエール独自対応 >>>>>
import { createSetCookie, parseCookie } from "@/utils/cookie";
// ライフエール独自対応 <<<<<

export default {
  name: 'MenuShare',
  mixins: [menu_utils, func_utils],
  components: {},
  props: {
    label: {
      type: String,
      default: 'シェア'
    },
    url: {
      type: String
    },
    success: {
      type: Function
    },
    error: {
      type: Function
    },
    facebook: {
      type: Boolean,
      default: true
    },
    twitter: {
      type: Boolean,
      default: true
    },
    line: {
      type: Boolean,
      default: true
    },
    email: {
      type: Boolean,
      default: true
    },
    copy: {
      type: Boolean,
      default: true
    },
    face: {
      type: Boolean,
      default: true
    },
    favorite: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'normal'
    },
    bodyEmail: {
      type: Object
    },
    menuBasicInfo: {
      type: Object,
      default: () => {}
    },
    social: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menuNo: null,
      isFavorite: false,
      favoriteId: null,
      popupLogin: false,
      popupShare: false,
      popupMail: false,
      errCode: '0',
      // ライフエール独自対応 >>>>>
      isAddedFavorite: false
      // ライフエール独自対応 <<<<<
    }
  },
  created() {
    const { menuNo } = this.$route.params
    this.menuNo = menuNo
  },
  mounted() {
    if (this.isLoggedIn && this.favorite) {
      this.getFavoriteStatus(this.menuNo).then(
        (result) => {
          this.favoriteId = get(result, 'id', '')
          this.isFavorite = get(result, 'favourite', false)
        },
        () => {}
      )
    }
  },
  watch: {
    bodyEmail: {
      deep: true,
      handler(val) {
        this.bodyEmail = val
      }
    }
  },
  computed: {
    isPlanDetailView() {
      const { menuNo, planId, roomId } = this.$route.params
      return (
        menuNo &&
        planId &&
        roomId &&
        this.$route.path === `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`
      )
    },
    copyLabel() {
      let label = ''
      let menuNm = this.menuBasicInfo?.menuNm
      if (this.isPlanDetailView) {
        const planDetail = this.$store.getters.planDetail
        label = planDetail?.planBasicInfo?.planNm
      }
      return [menuNm, label].filter(Boolean).join('\n')
    },
    shareFacebook() {
      if (this.url) {
        return `https://www.facebook.com/sharer/sharer.php?u=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`
    },
    shareTwitter() {
      if (this.url) {
        return `https://twitter.com/intent/tweet?text=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://twitter.com/intent/tweet?text=${url}`
    },
    shareLine() {
      if (this.url) {
        return `https://social-plugins.line.me/lineit/share?url=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://social-plugins.line.me/lineit/share?url=${url}`
    },
    shareEmail() {
      if (this.url) {
        return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${this.url}+&ui=2&tf=1&pli=1'`
      }
      // eslint-disable-next-line quotes
      return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${location.href}+&ui=2&tf=1&pli=1'`
    }
  },
  methods: {
    handleMail() {
      (this.popupMail = true), (this.errCode = '')
    },
    showShare() {
      this.popupShare = true
    },
    doCopy() {
      let label = this.copyLabel
      let url = this.url
      if (!url) {
        url = location.href
        // if (this.$route?.query?.hasOwnProperty('adultHeadCnt')) {
        //   url = `${url}?adultHeadCnt=${this.$route.query.adultHeadCnt}`
        // }
      }
      const copyData = [label, url].filter(Boolean).join('\n')
      this.$copyText(copyData).then(
        function (e) {
          alert('クリップボードにコピーしました')
        },
        function (e) {
          alert('クリップボードにコピーできませんでした')
        }
      )
    },
    handleFavorite() {
      // ライフエール独自対応 >>>>>
      const cookie = parseCookie(document.cookie);
      const path = location.pathname + location.search;
      // レベル1認証のログイン状態の確認
      if (!cookie.LYLv1AtLimitAuthenticatedCookie) {
        document.cookie = createSetCookie("back_uri", path);
        // レベル1認証画面に遷移
        window.open(
          process.env.VUE_APP_API_URL +
            "/v1/stay/sb-login?back_uri=" +
            process.env.VUE_APP_BASE_URL + path,
          "_self"
        );
      } else {
        // ユーザー情報有効期限の確認
        if (!cookie.LYUserLimitCookie) {
          window.open(
            process.env.VUE_APP_API_URL +
              "/v1/stay/sb-login?back_uri=" +
              process.env.VUE_APP_BASE_URL + path,
            "_self"
          );
        }
      }
      // ライフエール独自対応 <<<<<
      if (!this.isFavorite) {
        this.addFavorite(this.menuNo).then(
          () => {
            this.getFavoriteStatus(this.menuNo).then(
              (result) => {
                this.favoriteId = get(result, 'id', '')
                this.isFavorite = get(result, 'favourite', false)
                // ライフエール独自対応 >>>>>
                this.isAddedFavorite = true;
                this.$emit("handleFavorite", this.isAddedFavorite);
                const favorite = document.querySelector(
                  ".crly-m-common-footer-nav-item.crly-icon.favorite"
                );
                favorite.classList.add("animated");
                setTimeout(this.postAlert, 1000);
                // ライフエール独自対応 <<<<<
              },
              () => {}
            )
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      } else {
        this.removeFavorite(this.favoriteId).then(
          () => {
            this.getFavoriteStatus(this.menuNo).then(
              (result) => {
                this.favoriteId = get(result, 'id', '')
                this.isFavorite = get(result, 'favourite', false)
                // ライフエール独自対応 >>>>>
                this.isAddedFavorite = false;
                this.$emit("handleFavorite", this.isAddedFavorite);
                // ライフエール独自対応 <<<<<
              },
              () => {}
            )
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      }
    },
    // ライフエール独自対応 >>>>>
    postAlert() {
      const animation = document.querySelector("img.copy");
      animation?.addEventListener("animationend", this.onCompleteFavorite);
    },
    onCompleteFavorite() {
      alert("お気に入りに登録しました。");
      const animation = document.querySelector("img.copy");
      animation?.removeEventListener("animationend", this.onCompleteFavorite);
      this.isAddedFavorite = false;
      this.$emit("handleFavorite", this.isAddedFavorite);
    },
    // ライフエール独自対応 <<<<<
    sendMailToAddress($event) {
      const email = get($event, 'menuNo', '')
      if (!email) {
        this.errCode = '1'
      } else {
        let myEmail = null
        myEmail = email.trim()
        if (this.validEmail(myEmail.trim())) {
          const data = _.cloneDeep(this.bodyEmail)
          data.emailTo = myEmail
          data.typeShare = 1
          data.memberName = get(this.$store, 'getters.bs_app.info_user.username', '')
          this.$loading.show()
          this.$repositories('plan')
            .sendMailToAddress(data)
            .then(
              () => {
                this.popupMail = false
                this.$loading.hide()
              },
              (error) => {
                this.popupMail = false
                this.$toasted.error(error?.message)
                this.$loading.hide()
              }
            )
        } else {
          this.errCode = '2'
        }
      }
    },
    showPopup($event) {
      this.popupMail = $event
    },
    triggerSuccess(type, data) {
      this.$emit('success', {
        type,
        data
      })
    },
    triggerError(type, data) {
      this.$emit('error', {
        type,
        data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
